var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.092 1.005.13-.13a.314.314 0 0 1 .444 0L7.89 8.096c.061.061.16.061.222 0L15.334.874a.314.314 0 0 1 .444 0l.13.13a.314.314 0 0 1 0 .445L8.213 9.126a.314.314 0 0 1-.444 0L.092 1.449a.314.314 0 0 1 0-.444"
  })));
};
export default SvgCaretDown;